import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCopyComponent } from "./med-icon-copy.component";

@NgModule({
  declarations: [
    MedIconCopyComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCopyComponent,
  ],
})
export class MedIconCopyModule { }
